var { authenticator } = require("otplib");

// =======================================================
// Token settings
// =======================================================
const TOKEN_SECRET: string =
  (process.env.EHIRING_DYNAMIC_TOKEN_SECRET ?? "peoplexHiring") + "smc-pb19";
const TOKEN_STEP: number = parseInt(
  process.env.EHIRING_DYNAMIC_TOKEN_STEP || "300"
);
const TOKEN_WINDOW: number = parseInt(
  process.env.EHIRING_DYNAMIC_TOKEN_WINDOW || "1"
);
const TOKEN_LENGTH: number = parseInt(
  process.env.EHIRING_DYNAMIC_TOKEN_LENGTH || "12"
);

// =======================================================
// Setup authenticator
// =======================================================
authenticator.options = {
  step: TOKEN_STEP,
  window: TOKEN_WINDOW,
  digits: TOKEN_LENGTH,
};

if (typeof window === "undefined") {
  console.log("");
  console.log("╔═══════════════════════╗");
  console.log("║ OTPLIB TOKEN SETTINGS ║");
  console.log("╚═══════════════════════╝");
  console.log("TOKEN_STEP ───", TOKEN_STEP);
  console.log("TOKEN_WINDOW ─", TOKEN_WINDOW);
  console.log("TOKEN_LENGTH ─", TOKEN_LENGTH);
  console.log("");
}

// =======================================================
// Methods
// =======================================================
export function generateToken(): string {
  return authenticator.generate(TOKEN_SECRET);
}
